// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"f4272fcf","413":"3313bfe7","453":"231f798c","782":"6bd525d6","872":"6002ebc2"}[chunkId] + ".chunk.js";
};